import React, { useState, useEffect } from "react";

import { useAuth } from "../../../core/contexts/AuthContext";
import Spinner from "../../Common/UI/Spinner/Spinner";
import * as AccountApi from "../../Common/Apis/AccountApi";

const Redirect = (props) => {
  const [isLogin, setisLogin] = useState(false);
  const { authTokens, setAuthTokens } = useAuth();


  useEffect(() => {
    const processLogin = async () => {
      try {
        const resData = await AccountApi.getLoginBySSOToken(
          props.match.params.id
        );

        const userDetail = await AccountApi.getUserInformation({
          access_token: resData.access_token,
        });

        const menu = [];
        const rolePermissions = [];

        if (userDetail) {
          const newToken = {
            ...resData,
            expires_in: Date.now() / 1000 + Number(resData.expires_in),
            user_email: userDetail.EmailAddress,
            user_name: userDetail.FirstName + " " + userDetail.LastName,
            account_name: userDetail.AccountName,
            menu: menu
          };

          setAuthTokens(newToken, menu, rolePermissions);

          setisLogin(true);
        } else {
          props.history.push("/login");
        }
      } catch (_err) {
        //setLoading(false);

        props.history.push("/login");
      }
    };

    setAuthTokens(null);

    const loginTimeout = setTimeout(() => {
      processLogin();
    }, 500);

    return () => {
      clearTimeout(loginTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (isLogin && authTokens) {
      const path = "/locate";

      props.history.push(path);

    }
  }, [isLogin, authTokens, props.history]);

  return (
    <React.Fragment>
      <Spinner active={true} />
    </React.Fragment>
  );
};

export default Redirect;
